<template>
  <div class="alias-table">
    <div class="alias-table__header">
      <div class="title">{{ title }}</div>
      <i class="fa fa-lg fa-plus add-icon" title="Add alias" @click="handleAddAlias" />
    </div>

    <div class="alias-table__items-container">
      <ul v-if="items.length" class="items-list">
        <li v-for="(alias, index) in items" :key="`alias-${index}`">
          <div class="title">{{ alias }}</div>
          <div @click="handleRemoveAlias(alias)"><i class="fa fa-remove remove-icon"></i></div>
        </li>
      </ul>

      <div v-else class="items-empty">
        No items found
      </div>
    </div>

    <alias-add-modal
      :show.sync="showAddModal"
      :port-id="portId"
      :add-method="addMethod"
      :title="title"
      @update="reloadItems" />

    <alias-remove-modal
      :show.sync="showRemoveModal"
      :port-id="portId"
      :alias-name="selectedAlias"
      :remove-method="removeMethod"
      :title="title"
      @update="reloadItems" />

  </div>
</template>

<script>
import AliasAddModal from './modals/AliasAddModal'
import AliasRemoveModal from './modals/AliasRemoveModal'

export default {
  name: 'alias-table',

  components: {
    AliasRemoveModal,
    AliasAddModal
  },

  props: {
    portId: {
      type: Number,
      default: null,
    },
    title: {
      type: String,
      default: 'Aliases',
    },
    listMethod: {
      type: Function,
      default: () => {
        console.log('list method is not specified')
      },
    },
    addMethod: {
      type: Function,
      default: () => {
        console.log('add method is not specified')
      },
    },
    removeMethod: {
      type: Function,
      default: () => {
        console.log('remove method is not specified')
      },
    },
  },

  data() {
    return {
      showAddModal: false,
      showRemoveModal: false,
      items: [],
      selectedAlias: null,
    };
  },

  async mounted() {
    await this.loadAliases();
  },

  methods: {
    async resetAliasesData() {
      this.selectedAlias = null;
      this.items = [];
    },

    async loadAliases() {
      this.items = await this.listMethod(this.portId);
    },

    handleAddAlias() {
      this.showAddModal = true;
    },

    handleRemoveAlias(alias) {
      this.selectedAlias = alias;
      this.showRemoveModal = true;
    },

    async reloadItems() {
      await this.loadAliases();
    },
  },

  watch: {
    portId: async function(value) {
      if(value) {
        await this.loadAliases();
      } else {
        this.resetAliasesData();
      }
    },
  },
}
</script>

<style scoped lang="scss">
  .alias-table {
    padding: 15px 0;
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #b2b2b2;

      .title {
        font-size: 18px;
      }
      .add-icon {
        cursor: pointer;
        color: #008e00;
        padding: 0 5px;
      }
      .add-icon:hover {
        color: #00b400;
      }
    }

    &__items-container {
      margin: 15px 0;

      .items-list {
        padding: 0;

        li {
          padding: 3px 5px ;
          margin-bottom: 5px;
          list-style: none;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: #efefef;

          .title {
            font-size: 15px;
          }

          .remove-icon {
            cursor: pointer;
            font-size: 18px;
            color: #9a0000;
          }
          .remove-icon:hover {
            color: #f60000;
          }
        }
      }

      .items-empty {
        text-align: center;
        color: #a5a5a5;
      }
    }
  }


</style>